export const staircaseConfig = {
    gameSlug: 'wcst',
    category: 'foudre_logique',
    variable: 'n_items',
    startValue: 4,
    minValue: 2,
    maxValue: 8,
    stepSizesByPhase: [1, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 30,
    direction: 'up-easier',
};
function buildVariant(level) {
    if (level <= 10)
        return { level, label: 'Init' };
    if (level <= 20)
        return { level, label: 'Standard' };
    if (level <= 30)
        return { level, label: 'Tempo' };
    if (level <= 40)
        return { level, label: 'Tempo soutenu' };
    return { level, label: 'Expert' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    fixationMs: 300,
    feedbackMs: 600,
    itiMs: 500,
};
export const paradigmMeta = {
    slug: 'wcst',
    paradigm: 'Wisconsin Card Sorting Test (Berg 1948)',
    category: 'foudre_logique',
    goal: 'Flexibilite cognitive : detecter et adopter une regle qui change sans preavis.',
};
//# sourceMappingURL=params.js.map